import User from "../models/user.model";
import { A9Response } from "../types/sketchfabData";

export type MigrationRequestSuccessData = {
  message: string;
};

export type MigrationVerifyPeekData = {
  name: string;
  email: string;
};

export type MigrationVerifyConfirmData = {
  message: string;
  user: User;
  accessToken: string;
};

export const isA9Success = <T>(
  payload: unknown,
): payload is A9Response<T> & { status: true; data: T } =>
  Boolean((payload as A9Response<T> | undefined)?.status);

export const getA9Data = <T>(payload: unknown): T | undefined =>
  isA9Success<T>(payload) ? payload.data : undefined;

export const getA9ErrorMessage = (payload: unknown, fallback: string): string => {
  const envelope = payload as A9Response<unknown> | undefined;
  return envelope?.error?.message || fallback;
};

export const getA9SuccessMessage = (payload: unknown, fallback: string): string =>
  getA9Data<MigrationRequestSuccessData>(payload)?.message || fallback;
